import { Box, Button, Grid, useMediaQuery } from '@mui/material'
import { Navigation } from 'components/Navigation'
import React, { useEffect, useState } from 'react'
import { StyldeImage, StyledBurgerButton, StyledHeader } from './styled'
import logoImage from 'img/driveai-logo.png'
import { StyledDefaultContainer } from 'components/AppContainer/styled'
import { BurgerMenu } from 'components/BurgerMenu'
import { Menu } from 'lucide-react'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { AuthorizationButton } from 'components/Auth/AuthorizationButton'
import { light } from '@mui/material/styles/createPalette'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'
import { LicenseSelect } from 'components/LicenseSelect'
import { Link } from 'react-router-dom'

export const Header: React.FC = () => {
  const [open, setOpen] = useState(false)
  const media = useMediaQuery('(max-width:1199px)')
  const { isAuthenticated, isLoading } = useKindeAuth()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const { authUser } = useWpAuthContext()

  const toggleDrawer = () => {
    setOpen((open) => !open)
  }

  useEffect(() => {
    if (open === true && media === false) {
      setOpen(false)
    }
  }, [media])

  useEffect(() => {
    if (isAuthenticated && !authUser) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
    if (!isLoading) {
      if (isAuthenticated && authUser) {
        setIsLoggedIn(true)
      } else {
        setIsLoggedIn(false)
      }
    } else {
      setIsLoggedIn(false)
    }
  }, [isAuthenticated, isLoading, authUser])

  // useEffect(() => {
  //   if (isAuthenticated && !authUser) {
  //     setIsLoggedIn(true)
  //   } else {
  //     setIsLoggedIn(false)
  //   }
  // }, [isAuthenticated, authUser])

  return (
    <StyledHeader>
      <StyledDefaultContainer>
        <Grid
          container
          spacing={{ xs: 0, lg: 2 }}
          alignItems={{ xs: 'flex-start', lg: 'center' }}
          sx={{
            justifyContent: {
              xs: 'space-between'
            }
          }}
        >
          {media && (
            <Grid
              item
              xs={3}
              sx={{
                paddingTop: {
                  xs: '12px'
                }
              }}
            >
              <Box
                component="div"
                sx={{
                  display: {
                    xs: 'flex'
                  },
                  flexDirection: 'row'
                }}
              >
                <StyledBurgerButton onClick={toggleDrawer}>
                  <Menu color="var(--white)" width={32} height={32} />
                </StyledBurgerButton>
              </Box>
            </Grid>
          )}
          <Grid
            item
            xs={6}
            md={3}
            display={'flex'}
            justifyContent={{ xs: 'center', lg: 'inherit' }}
            sx={{
              paddingInlineEnd: {
                xs: '25px'
              }
            }}
          >
            <a href={`${window.location.origin}`}>
              <StyldeImage src={logoImage} alt="logo" />
            </a>
          </Grid>
          {!media && (
            <Grid
              item
              xs={6}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Navigation />
            </Grid>
          )}

          <Grid
            item
            xs={3}
            md={3}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            flexDirection={'row-reverse'}
            sx={{
              paddingTop: {
                xs: '12px'
              }
            }}
          >
            <LicenseSelect />
            {!media && (
              <Box marginInlineEnd={2}>
                <AuthorizationButton
                  type={isAuthenticated && isLoggedIn ? 'logout' : 'login'}
                  mode={'light'}
                  className="header"
                  isHeader
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </StyledDefaultContainer>
      <BurgerMenu open={open} toggleDrawer={toggleDrawer} />
    </StyledHeader>
  )
}
